<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div>
      <mu-row gutter>
        <mu-col width="80" desktop="50" tablet="70">
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-time-picker
                :label="$t('message.labelTime')"
                mode="portrait"
                fullWidth
                v-model="timeModel.time"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
              ></mu-time-picker>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-date-picker
                :label="$t('message.labelDate')"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
                :dateTimeFormat="dateFormat"
                format="DD-MM-YYYY"
                v-model="timeModel.date"
                :maxDate="maxDate"
                fullWidth
              ></mu-date-picker>
            </mu-col>
          </mu-row>
          <!-- First row -->
          <mu-row gutter v-if="preference == 'mmoll'">
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                hintText="Enter mmol/L"
                :data-vv-rules="'required|min_value:0|max_value:18.1'"
                data-vv-name="total_mmoll"
                data-vv-value-path="inputValue"
                data-vv-as="total"
                :errorText="errors.first('total_mmoll')"
                v-model.number="reading.total_mmoll"
                :label="$t('message.labelCholesterolTotal')"
                helpText="mmol/L"
                :fullWidth="true"/>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                hintText="Enter mmol/L"
                :data-vv-rules="'min_value:0|max_value: 18.1'"
                data-vv-name="hdl_mmoll"
                data-vv-value-path="inputValue"
                data-vv-as="hdl"
                :errorText="errors.first('hdl_mmoll')"
                v-model.number="reading.hdl_mmoll"
                :label="$t('message.labelCholesterolHDL')"
                helpText="mmol/L"
                :fullWidth="true"/>
            </mu-col>
          </mu-row>
          <mu-row gutter v-if="preference == 'mgdl'">
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                hintText="Enter mg/dL"
                :data-vv-rules="'required|min_value:0|max_value:700'"
                data-vv-name="total_mgdl"
                data-vv-value-path="inputValue"
                data-vv-as="total"
                :errorText="errors.first('total_mgdl')"
                v-model.number="reading.total_mgdl"
                :label="$t('message.labelCholesterolTotal')"
                :fullWidth="true"
                helpText="mg/dL"/>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                hintText="Enter mg/dL"
                :data-vv-rules="'min_value:0|max_value:700'"
                data-vv-name="hdl_mgdl"
                data-vv-value-path="inputValue"
                data-vv-as="hdl"
                :errorText="errors.first('hdl_mgdl')"
                v-model.number="reading.hdl_mgdl"
                :label="$t('message.labelCholesterolHDL')"
                :fullWidth="true"
                helpText="mg/dL"/>
            </mu-col>
          </mu-row>
          <!-- End first row -->

          <!-- Second row -->
          <mu-row gutter v-if="preference == 'mmoll'">
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                hintText="Enter mmol/L"
                :data-vv-rules="'min_value:0|max_value:18.1'"
                data-vv-name="triglycerides_mmoll"
                data-vv-value-path="inputValue"
                data-vv-as="triglycerides"
                :errorText="errors.first('triglycerides_mmoll')"
                v-model.number="reading.triglycerides_mmoll"
                :label="$t('message.labelCholesterolTriglycerides')"
                :fullWidth="true"
                helpText="mmol/L"/>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                hintText="Enter mmol/L"
                :data-vv-rules="'min_value:0|max_value: 18.1'"
                data-vv-name="ldl_mmoll"
                data-vv-value-path="inputValue"
                data-vv-as="hdl"
                :errorText="errors.first('ldl_mmoll')"
                v-model.number="reading.ldl_mmoll"
                :label="$t('message.labelCholesterolLDL')"
                :fullWidth="true"
                helpText="mmol/L"
              />
            </mu-col>
          </mu-row>
          <mu-row gutter v-if="preference == 'mgdl'">
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                hintText="Enter md/dL"
                :data-vv-rules="'min_value:0|max_value:700'"
                data-vv-name="triglycerides_mgdl"
                data-vv-value-path="inputValue"
                data-vv-as="triglycerides"
                :errorText="errors.first('triglycerides_mgdl')"
                v-model.number="reading.triglycerides_mgdl"
                :label="$t('message.labelCholesterolTriglycerides')"
                :fullWidth="true"
                helpText="mg/dL"/>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                hintText="Enter md/dL"
                :data-vv-rules="'min_value:0|max_value:700'"
                data-vv-name="ldl_mgdl"
                data-vv-value-path="inputValue"
                data-vv-as="hdl"
                :errorText="errors.first('ldl_mgdl')"
                v-model.number="reading.ldl_mgdl"
                :label="$t('message.labelCholesterolLDL')"
                :fullWidth="true"
                helpText="mg/dL"/>
            </mu-col>
          </mu-row>
          <!-- End second row -->
        </mu-col>
      </mu-row>
    </div>
    <mu-flat-button
      style="margin-right: 8px;"
      :label="$t('message.discardText')"
      @click.native="closeEditMode(reading)"
    ></mu-flat-button>
    <button type="submit" style="display: none;"></button>
    <mu-raised-button
      @click.native="submitForm"
      :disabled="isUpdating"
      :label="isUpdating ? $t('message.updatingText') : $t('message.updateText')"
      type="button"
      secondary
    ></mu-raised-button>
  </form>
</template>
<script>

  import CholesterolApi from '../../../../api/Tracking/Cholesterol'
  import ScrollerMixin from '../../../../mixins/ScrollerMixin'
  import TrackingEditMixin from '../../../../mixins/TrackingEditMixin'


  export default {
    mixins: [TrackingEditMixin, ScrollerMixin],
    name: 'cholesterol-edit',
    props: {
      preference: {
        type: String,
        default: 'mmoll'
      },
      item: {
        type: Object,
        default: {}
      },
    },
    data() {
      return {
        isUpdating: false,
        listTags: [],
        reading: {
          tags: []
        }
      }
    },
    mounted() {
      let self = this;
      self.$forceUpdate();
    },
    methods: {
      submitForm() {

        let self = this;
        let model = {};
        model.tracking_id = self.reading.tracking_id;
        model.progress_id = self.reading.progress_id;
        model.date = self.reading.date;

        if (self.preference === 'mmoll') {

          model.total_mmoll = self.reading.total_mmoll;
          model.ldl_mmoll = self.reading.ldl_mmoll;
          model.hdl_mmoll = self.reading.hdl_mmoll;
          model.triglycerides_mmoll = self.reading.triglycerides_mmoll
        }

        if (self.preference === 'mgdl') {
          model.total_mgdl = self.reading.total_mgdl;
          model.ldl_mgdl = self.reading.ldl_mgdl;
          model.hdl_mgdl = self.reading.hdl_mgdl;
          model.triglycerides_mgdl = self.reading.triglycerides_mgdl
        }

        self.isUpdating = true;
        CholesterolApi.updateCholesterolTracking(model)
          .then(function (response) {
            self.isUpdating = false;
            let offset = new Date();
            self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
            self.$EventBus.$emit('cholesterolReadingUpdated');
            self.$EventBus.$emit('updateGraphData');
            self.$emit('updateReading', self.reading);
            self.$emit('closeEditPanel')
          })
          .catch(function () {
            self.isUpdating = false;
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CholesterolEdit.vue?4f3d8666